import { Button, styled } from "@mui/material";

export const DeleteButton = styled(Button)(({
  theme
}) => ({
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '16px',
}));
